import { searchHistoryStyles } from "@insite/content-library/Widgets/Header/SearchHistory";
import { css } from "styled-components";

searchHistoryStyles.wrapper = {
	css: css`
		width: 300px;
		padding: 10px 20px 15px 20px;
    `,
}